import { createCtx } from '@nic/commons'
import { requestContactUpdateInitialState, requestContactUpdateReducer } from '@nic/nic-api'

const [ctx, Provider] = createCtx(requestContactUpdateReducer, requestContactUpdateInitialState)
export const ContactUpdatedContext = ctx
export const ContactUpdatedProvider = Provider
